'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'stroopwafel';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f551';
var svgPathData = 'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM75 188.1L52.4 210.7 97.6 256c-26.4 26.4-41.5 41.5-45.3 45.3L75 323.9c3.8-3.8 18.9-18.9 45.3-45.3l45.3 45.3-56.6 56.6-11.3 11.3 22.6 22.6 11.3-11.3 56.6-56.6 45.3 45.3c-26.4 26.4-41.5 41.5-45.3 45.3l22.6 22.6c3.8-3.8 18.9-18.9 45.3-45.3 26.4 26.4 41.5 41.5 45.3 45.3L323.9 437c-3.8-3.8-18.9-18.9-45.3-45.3l45.3-45.3 67.9 67.9 22.6-22.6-67.9-67.9 45.3-45.3c26.4 26.4 41.5 41.5 45.3 45.3l22.6-22.6c-3.8-3.8-18.9-18.9-45.3-45.3 26.4-26.4 41.5-41.5 45.3-45.3L437 188.1c-3.8 3.8-18.9 18.9-45.3 45.3l-45.3-45.3 56.6-56.6 11.3-11.3-22.6-22.6-11.3 11.3-56.6 56.6-45.3-45.3C305 93.8 320.1 78.8 323.9 75L301.3 52.4c-3.8 3.8-18.9 18.9-45.3 45.3l-45.3-45.3-22.6 22.6 45.3 45.3-45.3 45.3-56.6-56.6-11.3-11.3-22.6 22.6 11.3 11.3 56.6 56.6-45.3 45.3-45.3-45.3zm181 181l-45.3-45.3 45.3-45.3 45.3 45.3-45.3 45.3zm67.9-67.9l-45.3-45.3 45.3-45.3 45.3 45.3-45.3 45.3zM210.7 188.1l45.3-45.3 45.3 45.3-45.3 45.3-45.3-45.3zm-22.6 22.6l45.3 45.3-45.3 45.3-45.3-45.3 45.3-45.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStroopwafel = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;